<template>
  <v-carousel
    hide-delimiters
    show-arrows-on-hover
    
    :show-arrows="contests.length > 1"
    prev-icon="fa-angle-left"
    next-icon="fa-angle-right"
    :height="sliderHeight"
  >
    <v-carousel-item
      v-for="(contest,i) in contests"
      :key="i"
      eager
      :style="gradientStyle(contest.color_1,contest.color_2)"
      active-class="secondary"
      :to="`/contests/${contest.id}/${contest.slug}`"
    >
      <v-container fill-height>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="12" md="10" lg="8" xl="6" class="pt-0">
            <v-row  align="center">
              <v-col class="text-center" cols="3" lg="2" xl="2">
                <div
                  class
                  id="slider-desktop"
                  :style="`background-image:url(${contest.brand_logo})`"
                ></div>
              </v-col>
              <v-col class cols="9" lg="10" xl="10">
                <h3 class="mb-2 white--text">{{contest.title}}</h3>
                <p class="grey--text text--lighten-2">{{contest.description |limit_100}}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-carousel-item>
  </v-carousel>
</template>
<script>
export default {
  name: "",
  props: ["contests"],
  methods: {
    gradientStyle(color_1, color_2) {
      return `background: ${color_1};background: -webkit-linear-gradient(to right, ${color_1}, ${color_2});background: linear-gradient(to right, ${color_1}, ${color_2});`;
    }
  },
  computed: {
    sliderHeight() {
      return `140px`;
    }
  },
  data: () => ({})
};
</script>
<style lang="scss" scoped>
#slider-desktop {
  width: 100%;
  height: 100px;
  background-size: contain;
  background-position: center;
}
.gradient-bg {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#0067f4),
    to(#2bdadd)
  );
  background: linear-gradient(#0067f4 0%, #0067f4 50%, #2bdadd 100%);
}

</style>
